
'use client'
import { type FC, memo, useEffect } from 'react'
import styled from 'styled-components'
import { usePageDesign, useTranslator } from '@/hooks'
import { createUnderline, designGrid, getP18, getP50, getTransition, mq, vw } from '@/styles'
import { motion, type Variants } from 'motion/react'
import { FormContact } from './forms/FormContact'
import { NAVBAR_HEIGHTS } from './commons/layout/Navbar'



export const ContactSection:FC= memo(({  }) => {
  const { t } = useTranslator()
  const { setHeaderTextColor, setPageHasHeaderBgImage } = usePageDesign()

  useEffect(() => {
    setHeaderTextColor('dark')
    setPageHasHeaderBgImage(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  

  return (
    <Main>
      <div className='s-wrapper'>
        <motion.div variants={titleVariants}  initial='initial' animate='animateText' exit='exit'transition={{ ...getTransition(), duration: 0.5 }}>
          <h1>{t('project.contact_page.header.title')}</h1>
          <p dangerouslySetInnerHTML={{ __html: t('project.contact_page.header.subtitle') }} />
        </motion.div>
        <FormContact />
      </div>
    </Main>
  )
})

const Main = styled.main`
  .s-wrapper {
    ${designGrid({})}
    width: 100vw;
    width: 100dvw;
    margin-top: ${vw(NAVBAR_HEIGHTS.mobile, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      margin-top: ${vw(NAVBAR_HEIGHTS.mobile, 'tablet')};
    }

    ${mq.greaterThan('desktop')} {
      margin-top: ${vw(NAVBAR_HEIGHTS.desktop, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-top: ${NAVBAR_HEIGHTS.desktop}px;
    }

    > div {
      grid-column: 1 / span 6;
      grid-row: 1 / span 1;
      margin-bottom: 25px;

      ${mq.greaterThan('tablet')}{
        margin-bottom: 45px;
        grid-column: 1 / span 12;
        grid-row: 1 / span 1;
      }
    }
    
    h1 {
      ${getP50()}
      margin-bottom: 30px;
      margin-top: 30px;
    }

    p {
      ${getP18()}
      text-align: center;
      opacity: .4;
    }

    a {
      ${createUnderline({ reverse: true })};
      text-decoration: none;
    }

  }
`

const titleVariants:Variants = {
  initial: {
    y: '20px',
    opacity: 0,
    transition: {
      ...getTransition()
    }
  },
  animateText: {
    y: '0px',
    opacity: 1,
    transition: {
      ...getTransition(),
      ease: [.32,0,.29,.99],
      duration: .5,
      staggerChildren: 2
    }
  },
  exit: {
    y: '20px',
    opacity: 0,
    transition: {
      ...getTransition(),
      duration: .5
    }
  },
}